import axios, { AxiosResponse, CancelToken } from "axios"
import { RemesaDtoProps } from "./DTOs/RemesaDto"
import { RemesaFlujoTesoreriaDtoProps } from "./DTOs/RemesaFlujoTesoreriaDto"
import { RemesaReadingDtoProps } from "./DTOs/RemesaReadingDto"
import { RemesaReadingFilteredDtoProps } from "./DTOs/RemesaReadingFilteredDto"
import {
  remesaFlujoTesoreriaDtoAdapter,
  remesaReadingDtoAdapter,
  remesaReadingFilteredDtoAdapter,
} from "./Remesa.adapter"
import { RemesaReadingFilteredDtoIPagedEnumerableProps } from "./Schemas/RemesaReadingFilteredDtoIPagedEnumerable"
import { TipoFlujoTesoreriaType } from "./Types/TipoFlujoTesoreria"
import { SortingCriteria } from "./interfaces/SortingCriteria"

export interface GetRemesasByFiltersParamsProps {
  FechaLowerLimit?: string
  FechaUpperLimit?: string
  ImporteLowerLimit?: number
  ImporteUpperLimit?: number
  Keyword?: string
  TipoRemesa?: TipoFlujoTesoreriaType
  SortingCriteria?: SortingCriteria
  IsEnabled?: boolean
  MaxResultCount?: number
  SkipCount?: number
}

export async function getRemesasByFilters(
  queryParams: GetRemesasByFiltersParamsProps,
  cancelToken?: CancelToken
): Promise<RemesaReadingFilteredDtoIPagedEnumerableProps> {
  const { data } = await axios.get("/Remesa/by-filters", {
    params: queryParams,
    cancelToken,
  })
  return {
    currentPage: data?.currentPage,
    items: data?.items.map((item: RemesaReadingFilteredDtoProps) =>
      remesaReadingFilteredDtoAdapter(item)
    ),
    totalCount: data?.totalCount,
  }
}

export async function getRemesaById(
  id: string,
  cancelToken?: CancelToken
): Promise<RemesaReadingDtoProps> {
  const { data } = await axios.get(`/Remesa/${id}`, {
    cancelToken,
  })
  return remesaReadingDtoAdapter(data)
}

export async function getRemesaFlujoTesoreriaById(
  id: string,
  cancelToken?: CancelToken
): Promise<Array<RemesaFlujoTesoreriaDtoProps>> {
  const { data } = await axios.get(`/Remesa/${id}/flujos-tesoreria`, {
    cancelToken,
  })
  return data?.map((item: RemesaFlujoTesoreriaDtoProps) =>
    remesaFlujoTesoreriaDtoAdapter(item)
  )
}

export async function updateRemesaById(
  id: string,
  remesa: RemesaDtoProps,
  cancelToken?: CancelToken
): Promise<AxiosResponse> {
  const res = await axios.put(`/Remesa/${id}`, remesa, {
    cancelToken,
  })
  return res
}

export async function exportRemesaFlujosTesoreriaToExcelById(
  id: string,
  cancelToken?: CancelToken
): Promise<AxiosResponse> {
  const res = await axios.get(`/Remesa/${id}/flujos-tesoreria/exportar-excel`, {
    responseType: "blob",
    cancelToken,
  })
  return res
}
